import { http } from './config'

export default {

  getAllProductCriticalities: () => {
    return http.get('product_criticalities')
  },

  getFilteredProductCriticalities: (params) => {
    return http.get('product_criticalities', {params})
  },

  getProductCriticalityById: (productCriticalityID) => {
    return http.get('product_criticalities/' + productCriticalityID)
  },

  createProductCriticality: (productCriticalityParams) => {
    return http.post('product_criticalities', {
      name: productCriticalityParams.name,
    }
  )},

  updateProductCriticality: (productCriticalityParams) => {
    return http.put('product_criticalities/' + productCriticalityParams.id, {
      name: productCriticalityParams.name,
    }
  )},

  deleteProductCriticality: (productCriticalityID) => {
    return http.delete('product_criticalities/' + productCriticalityID)
  }

}
